module.exports = __webpack_public_path__ + "img/E3.30c24a02.png";